<template>
  <div class="container login">
    <el-row type="flex" class="login-top" :gutter="20">
      <el-col :lg="12" :md="12" :sm="24" :xs="24">
        <img class="login-bg" :src="`${$g.imgPrefix}/img/login/Group1000005887@2x.webp`">
      </el-col>
      <el-col :lg="12" :md="12" :sm="24" :xs="24" class="login-content">
        <img class="dot" :src="`${$g.imgPrefix}/img/home/Cardscreens@2x.png`">
        <div class="login-box">
          <template v-if="showLoginOrRegister">
            <!-- 登录或注册-->
            <div class="title mb-8 tc">{{$t('login.welcomelogin')}}</div>
            <el-form ref="loginRef" :rules="rules" :model="form" label-position="top" @keyup.enter.native="loginClick">
              <!-- 邮箱-->
              <el-form-item :label="$t('home.emailaddress')" prop="email">
                <el-input
                    :placeholder="$t('home.emailaddress')"
                    clearable
                    autocomplete="off"
                    v-model.trim="form.email"/>
              </el-form-item>
              <!-- 登录-->
              <el-form-item>
                <el-button type="primary" @click="loginClick">{{$t('login.login')}}</el-button>
              </el-form-item>
            </el-form>
            <!-- 或使用您的邮箱-->
            <el-divider content-position="center">{{$t('login.useemail')}}</el-divider>
            <div class="login-link">
              <div v-google-signin-button="clientId">
                <img :src="`${$g.imgPrefix}/img/login/Group 1000005851@2x.webp`">
              </div>
              <fb-signin-button
                  :params="fbSignInParams"
                  @success="onSignInSuccess"
                  @error="onSignInError"
                >
                 <img :src="`${$g.imgPrefix}/img/login/Group1000005852@2x.webp`">
              </fb-signin-button>
              <!-- <img :src="`${$g.imgPrefix}/img/login/Group1000005852@2x.webp`"> -->
              <!-- <img :src="`${$g.imgPrefix}/img/login/Group1000005853@2x.webp`"> -->
            </div>
            <div class="login-confirm">
              <span>
                <!-- 继续，即表示您同意我们的-->
                {{$t('login.agree')}}
                <!-- 退款政策-->
                <span class="green-text-2 cursor-pointer" @click="goPage('helpdetail',{id:10})">
                  {{$t('footer.refundpolicy')}}
                </span>
                <!-- 和-->
                {{$t('login.and')}}
                <!-- 使用条款-->
                <span class="green-text-2 cursor-pointer" @click="goPage('helpdetail',{id:9})">
                   {{$t('footer.termsofuse')}}
                </span>
                <!-- 并确认-->
                {{$t('login.andconfirm')}}
              </span>
              <div>
                <!-- 您已阅读我们的-->
                {{$t('login.readour')}}
                <!-- 隐私政策-->
                <span class="green-text-2 cursor-pointer" @click="goPage('helpdetail',{id:11})">
                   {{$t('footer.privacypolicy')}}
                </span>
              </div>
            </div>
          </template>
          <captcha v-if="showCaptcha"
                   ref="captcha"
                   :email="form.email"
                   :isOldUser="isOldUser"
                   @passwordLogin="passwordLogin"
                   @setPassword="setPassword">
            <!-- 验证邮箱-->
            <div class="title mb-8 tc" slot="captcha-title">{{$t('login.verifyemail')}}</div>
          </captcha>
          <setPassword
              v-if="showSetPassword"
              ref="setPassword"
              :email="form.email"
              :code="form.code"
          />
          <password v-if="showPassword" ref="password" :email="form.email" @captchaLogin="captchaLogin"/>
        </div>
      </el-col>
    </el-row>
    <div class="login-claim">
      <div class="mb-2">Copyright &copy; 2024 China Guangxi Nanning Yuanchuang Trading Co., Ltd.and ZHONGLING TRADE LIMITED</div>
      <div>E-mail consultation: delecia@alongshare.com</div>
<!--      &lt;!&ndash; 所有版权、商标、服务标记均属于相应所有者。&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_10')}}</div>-->
<!--      &lt;!&ndash; 版权所有 © 2024 GAMESGO LIMITED 保留所有权利（Unit 1804 South Bank Tower, 55 Upper Ground, London, SE1 9EY）&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_11')}}</div>-->
<!--      &lt;!&ndash; 附带条约 和隐私政策&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_12')}}</div>-->
    </div>
  </div>
</template>

<script>
import {
  isEmail
} from "@/util/validate";
import {
  getLoginCode,
  codelogin,
  register,
  googlelogin,
  facebooklogin
} from "@/request/requests";
import {
  isEmpty,
  MessageError,
  startLoading,
  MessageSuccess
} from "@/util/util";
import captcha from "../compontents/captcha";
import setPassword from "../compontents/setPassword";
import password from "../compontents/password";
import GoogleSignInButton from 'vue-google-signin-button-directive'
import jsonwebtoken from 'jsonwebtoken'
export default {
  directives: {
        GoogleSignInButton
    },
  name: "pcLogin",
  inject:['reload','reloadApp'],
  components: {
    captcha,
    setPassword,
    password
  },
  data() {
    const validateEmail = (rules, value, cb) => {
      if (!isEmail(value)) {
        return cb(new Error(this.$t('home.emailerror')));
      }
      return cb();
    }
    return {
      //默认新用户
      isOldUser: false,
      clientId: '398083746235-90dd311t5aem2j1rjhes07sto6e5no44.apps.googleusercontent.com',
      fbSignInParams: {
          scope: 'email,user_likes',
          return_scopes: true
        },
      showLoginOrRegister: true,
      showCaptcha: false,
      showSetPassword: false,
      showPassword: false,
      screenWidth: null,
      form: {
        email: '',
        code: ''
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t('home.pleaseenter') + ' ' + this.$t('home.emailaddress'),
            trigger: 'blur'
          },
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          },
        ]
      }

    }
  },
  methods: {
    OnGoogleAuthSuccess(idToken) {
            const jsondate = jsonwebtoken.decode(idToken);
            let data = {
                usercode: this.$cookies.get("usercode"),
                name: jsondate.name,
                email: jsondate.email,
                avatar: jsondate.picture,
                thirduserid: jsondate.sub
            }
            this.googlelogin(data)
        },
        OnGoogleAuthFail(error) {
            console.log(error)
            MessageError(error)
        },
        onSignInSuccess(response) {
            console.log(response) //返回第三方的登录信息 tolen等
            if (response.status == 'connected') {
                let data = {
                    usercode: this.$cookies.get("usercode"),
                    token: response.authResponse.accessToken,
                }
                console.log(response.authResponse.accessToken)
                console.log(data)
                this.facebooklogin(data)
            }
        },
        onSignInError(error) {
            //登录失败回调
            console.log(error)
            MessageError(error)
        },
    loginClick() {
      this.$refs['loginRef'].validate((valid) => {
        if (!valid) return;
        //调接口 从接口获取当前邮箱是首次登录||已有用户  首次新用户：显示验证码模块||老用户：显示密码登录模块
        this.toLogin();
      })
    },
    async toRegister() {
      let params = {
        email: this.form.email,
        client: 'mob'
      }
      let res = await register(params)
      if (res.status == "200") {
        this.showCaptcha = true;
        this.isOldUser = false;
        this.showLoginOrRegister = false;
      }else{
        MessageError(res.msg);
      }
    },
    async toLogin() {
      let loading = startLoading()
      // 登录
      let res = await getLoginCode(this.form.email,0)
      // this.showLoginOrRegister = false;
      // this.showPassword = true;
      // this.isOldUser = true;
      // loading.close()
      if (res.status == "200") {
        this.showLoginOrRegister = false;
        loading.close()
        //首次新用户：显示验证码模块
        if (isEmpty(res.data)) {
          this.showCaptcha = true;
          this.isOldUser = false;
          //this.toRegister(this.form.email);
        } else {
          //this.loginRes(res);
          //老用户：显示密码登录模块
          this.showPassword = true;
          this.isOldUser = true;
        }
      } else {
        this.showLoginOrRegister = false;
        this.showPassword = true;
        this.isOldUser = true;
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
    },
    loginRes: function (result) {
      let {
        userInfo,
        token,
        deadline
      } = result.data;
      // let {
      //   name: name
      // } = userInfo;
      this.$cookies.set("userInfo", JSON.stringify(userInfo), "7d");
      this.$cookies.set("token", token, "7d");
      this.$cookies.set("deadline", Date.parse(deadline), "7d");

      // this.$notification.success({
      //   message: "Login successful",
      //   description: `Welcome back，${name}`
      // });
      // if (localStorage.lang == 'kr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLogin)
      // } else if (localStorage.lang == 'it') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginIt)
      // } else if (localStorage.lang == 'ar') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginAr)
      // } else if (localStorage.lang == 'fr') {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginFr)
      // } else {
      //   this.$store.commit('setMenuListData', this.$store.state.map.menuListLoginEn)
      // }
      // this.$router.push({
      //   name: "home"
      // });
    },
    captchaLogin() {
      this.showCaptcha = true;
      this.showPassword = false;
    },
    passwordLogin() {
      this.showCaptcha = false;
      this.showPassword = true;
    },
    async setPassword(code) {
      this.form.code = code;
      let loading = startLoading();
      let res = await codelogin(this.form)
      if (res.status == "200") {
        loading.close()
        this.loginRes(res);
        this.showCaptcha = false;
        //新用户：设置密码
        if (!this.isOldUser) {
          this.showSetPassword = true;
        } else {
          //老用户: 到首页
          if (this.screenWidth > 576.98) {
            this.goPage('home');
          } else {
            this.goPage('phonehome');
          }
        }
      } else {
        loading.close()
        MessageError(res.msg)
      }
      loading.close()
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },
    windowsBack(){
      //-------------密码登录-----------
      if(this.showPassword){
        this.showPassword = false;
        //邮箱登录或注册
        this.showLoginOrRegister = true;
      }
      //-------------设置密码-----------
      if(this.showSetPassword){
        this.showSetPassword = false;
        //验证码登录
        this.showCaptcha = true;
      }
      //-------------验证码登录-------------
      if(this.showCaptcha){
        this.showCaptcha = false;
        //老用户
        if(this.isOldUser){
          //密码登录
          this.showPassword = true;
        }else{
          //新用户
          //邮箱登录或注册
          this.showLoginOrRegister = true;
        }
      }
      //this.$router.replace({ name: 'login' });
    },
    // 谷歌登录 
    async facebooklogin(data) {
            let loading = startLoading()
            let res = await facebooklogin(data)
            if (res.status == "200") {
                loading.close()
                MessageSuccess("Login successful!")
                this.gologinRes(res);
            } else {
                loading.close()
                MessageError(res.msg)
            }
            loading.close()
        },
    async googlelogin(data) {
            let loading = startLoading()
            let res = await googlelogin(data)
            if (res.status == "200") {
                loading.close()
                MessageSuccess("Login successful!")
                this.gologinRes(res);
            } else {
                loading.close()
                MessageError(res.msg)
            }
            loading.close()
        },
    gologinRes(result){
      let { userInfo, token, deadline } = result.data;
            let { name: name } = userInfo;
            this.$cookies.set("userInfo", JSON.stringify(userInfo), "7d");
            this.$cookies.set("token", token, "7d");
            this.$cookies.set("deadline", Date.parse(deadline), "7d");
            this.$notification.success({
                message: "Login successful",
                description: `Welcome back，${name}`,
            });
            this.reloadApp();
            // this.$router.push({ name: "home" });
            if('ontouchstart' in document.documentElement||!this.screenWidth > 576.98){
							console.log("TCL: phonehome -> ", )
              this.goPage('phonehome');
            }else{
              this.goPage('home');
							console.log("TCL: home -> ", )
            }
    },
    goPage(page, params) {
      if (!isEmpty(params)) {
        this.$router.push({
          name: page,
          query: params
        })
        return
      }
      this.$router.push({
        name: page
      })
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.windowsBack, false);
      window.addEventListener('popstate', this.windowsBack,false);
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
    window.removeEventListener('popstate', this.windowsBack, false);
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/login.scss";
</style>